document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("Product-Overlay");
  const buttons = document.querySelectorAll('[data-ref^="formTrigger-"]');

  buttons.forEach(function (button) {
    button.addEventListener("click", function () {
      const dataRef = button.getAttribute("data-ref").replace("formTrigger-", "");
      const drawer = document.getElementById(`ProductDrawer-${dataRef}`);

      overlay.style.display = "block";
      drawer.style.display = "flex";
      setTimeout(() => {
        drawer.style.transition = "right 0.2s ease-in-out";
        drawer.style.right = "0";
        overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
      }, 100);
    });
  });

  const closeButtons = document.querySelectorAll(".drawer__close");
  closeButtons.forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function () {
      const dataDrawer = closeBtn.getAttribute("data-drawer");
      if (dataDrawer) { 
        const drawer = document.getElementById(`ProductDrawer-${dataDrawer}`);
        if (drawer) { 
          closeDrawer(drawer);
        } else {
          console.error(`Drawer with ID 'ProductDrawer-${dataDrawer}' not found.`);
        }
      } else {
        console.error("Attribute 'data-drawer' not found on close button.");
      }
    });
  });

  function closeDrawer(drawer) {
    drawer.style.transition = "right 0.2s ease-in-out";
    drawer.style.right = "-450px";
    overlay.style.backgroundColor = "rgba(0, 0, 0, 0)";
    setTimeout(() => {
      drawer.style.display = "none";
      overlay.style.display = "none";
    }, 200); 
  }

  overlay.addEventListener("click", function () {
    overlay.style.display = "none";
    document.querySelectorAll(".product-drawer").forEach(function (drawer) {
      drawer.style.display = "none";
    });
  });

  function updatePosition() {
    document.querySelectorAll(".product-drawer").forEach(function (drawer) {
      if (window.innerWidth <= 450) {
        drawer.style.width = "100%";
        drawer.style.maxWidth = "450px"; 
        drawer.style.height = "100%";
      } else {
        drawer.style.width = "450px";
        drawer.style.height = "100%";
      }
    });
  }

  updatePosition();
  window.addEventListener("resize", updatePosition);
});
